// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__f0o1J","loading":"skeleton_loading__pFx6w"};